<template>
  <section class="section">
    <div class="hero" v-if="errorMessages">
      {{ errorMessages }}
    </div>
    <div class="columns" v-for="tasks in arranged" v-bind:key="tasks.id">
      <!-- 1つめのcolumn -->
      <div class="column is-3" v-for="task in tasks" v-bind:key="task.id">
        <article class="panel is-link">
          <p class="panel-heading">
            {{ shortMsg(task.task_title, 12) }}
          </p>
          <div class="panel-block">
            <hooper>
              <slide>
                <img :src="task.nearImage">
              </slide>
              <slide>
                <img :src="task.distantImage">
              </slide>
              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>
          </div>
          <div class="panel-block">
            <span class="letter-msg">{{ shortMsg(task.comment, 45) }}</span>
          </div>
          <div class="panel-block">
            登録日:{{ task.created_at }}
          </div>
          <div class="panel-block">
            <template  v-if="task.official_kakunin === '0'">
              <button class="button is-info is-rounded" @click="checkTask(task)">チェック</button>
            </template>
            <template v-else>
              <label :for="'check'+task.id">チェック済み</label>
              <input type="checkbox" :id="'check'+task.id" disabled checked>
            </template>
            <button class="button is-success is-rounded" @click="editTask(task)">編集</button>
          </div>
        </article>
      </div>
      <!-- 1つめのcolumn end-->
    </div>
    <InfiniteLoading :identifier="infiniteId" @infinite="infiniteHandler">
      <div slot="no-more"></div>
      <div slot="no-results">検索結果がありません</div>
    </InfiniteLoading>
    <transition name="fade">
      <a href="#" v-scroll-to="'#top'" class="scroll-top" v-show="isScrollShow">
        <i class="fa fa-angle-up fa-lg scroll-top__ico"></i>
      </a>
    </transition>
  </section>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper'
import 'hooper/dist/hooper.css'
import { mapState } from 'vuex'

export default {
  data: function(){
    return {
      infiniteId: +new Date(),
      limit: 10,
      page: 1,
      scrollY: 0,
      slicePar: 4, // rawを切り分ける個数
      loading: false,
    }
  },
  created(){
      this.$store.dispatch('official/clearHistory')
  },
  computed:{
    ...mapState({
      complete: state => state.official.complete,
      getTasks: state => state.official.tasks,
      apiStatus: state => state.official.apiStatus,
      errorMessages: state => state.official.errorMessages
    }),
    arranged: function(){
      let dist = [[]]
      this.getTasks.forEach((el) => {
        let tail = dist.length -1
        dist[tail].push(el)
        if(dist[tail].length > this.slicePar -1) dist.push([])
      })
      return dist
    },
    isScrollShow() {
      return this.scrollY > 200 ? true : false;
    },
  },
  components: {
    InfiniteLoading,
    Hooper,
    Slide,
    HooperPagination,
  },
  mounted(){
    this.$store.dispatch('official/clearHistory')
    // スクロールを取得
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("load", () => {
      this.onScroll();
    })
  },
  methods:{
    onScroll() {
      this.scrollY = window.pageYOffset;
    },
    async infiniteHandler($state){
      if (this.loading) return; // 読み込み中ならスキップ
      this.loading = true;
      await this.$store.dispatch('official/getOfficialTask',
        {
          limit: this.limit,
          page: this.page,
          select_status: this.selectedItem
        }
      )
      if(this.apiStatus){
        this.loading = false;
        if(this.complete) {
          $state.complete()
          return
        }
        this.page += 1
        $state.loaded()
      }
    },
    async checkTask(task){
      await this.$store.dispatch('official/officialCheck', { id: task.id })
      if(this.apiStatus){
        this.$swal('チェックしました!')
        this.$set(task, 'official_kakunin', 1)
      }
    },
    editTask(task){
      this.$router.push( { path: `/task/edit/${task.id}` })
    },
    shortMsg(strMsg, sliceNum){
      if(strMsg.length > sliceNum){
        return strMsg.slice(0, sliceNum) + '....'
      }
      return strMsg
    }
  }
}
</script>

<style scoped>
  .hooper-slide {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border: 2px solid #fff;
    border-radius: 10px;
  }
  .scroll-top {
    position: fixed;
    bottom: 32px;
    right: 32px;
    background-color: #000;
    padding: 10px 16px;
    border-radius: 32px;
  }
  .scroll-top__ico {
    font-weight: bold;
    font-size: 20px;
    color: #fff;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .letter-msg{
    white-space: pre-wrap;
  }
</style>